import { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  Profile,
  SanitizedProfileSettingsParams,
  updateProfileSettings,
} from '@utils/backend-api/profileSettings';

import { PROFILE_SETTINGS_KEY } from './useProfile';

export default function useProfileUpdate(userId: number) {
  const queryClient = useQueryClient();
  const [saveStatus, setSaveStatus] = useState('');
  const [showSave, setShowSave] = useState(false);
  const [error, setError] = useState('');
  const {
    mutate: saveProfile,
    data: profileData,
    isLoading: isSavingProfile,
  } = useMutation(
    async (values: SanitizedProfileSettingsParams) => await updateProfileSettings(userId, values),
    {
      onSuccess: (data: Profile) => {
        queryClient.setQueryData([PROFILE_SETTINGS_KEY], data);
        setShowSave(true);
        setSaveStatus('Saved');
        setTimeout(() => {
          setShowSave(false);
        }, 3000);
      },
      onError: (_err, _variables) => {
        setError('Something went wrong');
        setSaveStatus('Something went wrong');
      },
    }
  );

  return { saveProfile, profileData, isSavingProfile, saveStatus, showSave, error };
}
